import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, LinkedinIcon, FacebookIcon, ArrowRightIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-teal text-cream pt-20 pb-10 px-6 md:px-12" data-id="element-28">
      <div className="max-w-7xl mx-auto" data-id="element-29">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 mb-16" data-id="element-30">
          {/* Brand */}
          <div className="md:col-span-2" data-id="element-31">
            <h3 className="font-heading font-bold text-2xl mb-6" data-id="element-32">
              Fore River Creative Co.
            </h3>
            <p className="text-cream/80 max-w-sm mb-8" data-id="element-33">
              A founder-led creative agency blending strategy and aesthetics to
              build brand presence that converts.
            </p>
            <div className="flex gap-4" data-id="element-34">
              <a href="#" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-coral transition-colors" aria-label="Instagram" data-id="element-35">
                <InstagramIcon size={20} data-id="element-36" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-coral transition-colors" aria-label="LinkedIn" data-id="element-37">
                <LinkedinIcon size={20} data-id="element-38" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-coral transition-colors" aria-label="Facebook" data-id="element-39">
                <FacebookIcon size={20} data-id="element-40" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-41">
            <h4 className="font-heading font-semibold text-lg mb-6" data-id="element-42">
              Navigation
            </h4>
            <ul className="space-y-4" data-id="element-43">
              <li data-id="element-44">
                <Link to="/" className="text-cream/80 hover:text-coral transition-colors" data-id="element-45">
                  Home
                </Link>
              </li>
              <li data-id="element-46">
                <Link to="/services" className="text-cream/80 hover:text-coral transition-colors" data-id="element-47">
                  Services
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/portfolio" className="text-cream/80 hover:text-coral transition-colors" data-id="element-49">
                  Portfolio
                </Link>
              </li>
              <li data-id="element-50">
                <Link to="/about" className="text-cream/80 hover:text-coral transition-colors" data-id="element-51">
                  About
                </Link>
              </li>
              <li data-id="element-52">
                <Link to="/process" className="text-cream/80 hover:text-coral transition-colors" data-id="element-53">
                  Process
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-54">
            <h4 className="font-heading font-semibold text-lg mb-6" data-id="element-55">Contact</h4>
            <ul className="space-y-4 text-cream/80" data-id="element-56">
              <li data-id="element-57">
                <a href="mailto:Lauren@Forerivercreativeco.com" className="hover:text-coral transition-colors flex items-center gap-2" data-id="element-58">
                  Lauren@Forerivercreativeco.com
                </a>
              </li>
              <li data-id="element-59">
                <a href="tel:7819857277" className="hover:text-coral transition-colors" data-id="element-60">
                  781-985-7277
                </a>
              </li>
              <li data-id="element-61">Weymouth, MA</li>
            </ul>
            <Link to="/contact" className="inline-flex items-center gap-2 mt-6 text-coral font-semibold hover:text-coral-light transition-colors" data-id="element-62">
              Let's work together <ArrowRightIcon size={16} data-id="element-63" />
            </Link>
          </div>
        </div>

        <div className="border-t border-cream/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-cream/60" data-id="element-64">
          <p data-id="element-65">
            © {new Date().getFullYear()} Fore River Creative Co. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-66">
            <Link to="#" className="hover:text-cream transition-colors" data-id="element-67">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-cream transition-colors" data-id="element-68">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}